import React, { useEffect, useState } from "react";

import {
    getDashboard,
    getInventory
} from "../services/api";

import {
    BarChart3,
    RefreshCw
} from "lucide-react";


const Reports = () => {

    const [dashboard, setDashboard] =
        useState(null);

    const [inventory, setInventory] =
        useState([]);


    const load = async () => {

        try {

            const [
                dashboardResponse,
                inventoryResponse
            ] = await Promise.all([
                getDashboard(),
                getInventory()
            ]);


            setDashboard(
                dashboardResponse.data.data
            );

            setInventory(
                inventoryResponse.data.data || []
            );

        } catch (err) {

            console.error(err);

        }

    };


    useEffect(() => {
        load();
    }, []);


    if (!dashboard) {

        return (
            <div className="page-loading">
                Loading reports...
            </div>
        );

    }


    const summary =
        dashboard.summary || {};


    return (
        <div className="page-container">

            <div className="page-header">

                <div>

                    <h2>
                        Reports
                    </h2>

                    <p>
                        Cold storage operational reports
                    </p>

                </div>


                <button
                    className="primary-button"
                    onClick={load}
                >
                    <RefreshCw size={16} />
                    Refresh
                </button>

            </div>


            <div className="stats-grid">

                <div className="stat-card">
                    <div className="stat-icon blue">
                        <BarChart3 />
                    </div>

                    <span>
                        Total Capacity
                    </span>

                    <strong>
                        {summary.totalCapacityTons}
                        {" Tons"}
                    </strong>
                </div>


                <div className="stat-card">

                    <span>
                        Occupied
                    </span>

                    <strong>
                        {summary.occupiedTons}
                        {" Tons"}
                    </strong>

                </div>


                <div className="stat-card">

                    <span>
                        Available
                    </span>

                    <strong>
                        {summary.availableTons}
                        {" Tons"}
                    </strong>

                </div>


                <div className="stat-card">

                    <span>
                        Total Bags
                    </span>

                    <strong>
                        {Number(
                            summary.totalBags || 0
                        ).toLocaleString(
                            "en-IN"
                        )}
                    </strong>

                </div>

            </div>


            <div className="content-card">

                <div className="card-header">

                    <div>
                        <h3>
                            Chamber Report
                        </h3>

                        <p>
                            Chamber-wise storage utilization
                        </p>
                    </div>

                </div>


                <div className="table-wrapper">

                    <table>

                        <thead>

                            <tr>
                                <th>Chamber</th>
                                <th>Capacity</th>
                                <th>Occupied</th>
                                <th>Available</th>
                                <th>Occupancy</th>
                            </tr>

                        </thead>


                        <tbody>

                            {dashboard.chambers.map(
                                chamber => (

                                    <tr key={chamber.id}>

                                        <td>
                                            <strong>
                                                {chamber.chamberNo}
                                            </strong>
                                        </td>

                                        <td>
                                            {chamber.capacityTons}
                                            {" Tons"}
                                        </td>

                                        <td>
                                            {chamber.occupiedTons}
                                            {" Tons"}
                                        </td>

                                        <td>
                                            {chamber.availableTons}
                                            {" Tons"}
                                        </td>

                                        <td>
                                            {chamber.occupancyPercentage}
                                            %
                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>


            <div className="content-card">

                <div className="card-header">

                    <div>
                        <h3>
                            Inventory Report
                        </h3>

                        <p>
                            Current active lots
                        </p>
                    </div>

                </div>


                <div className="table-wrapper">

                    <table>

                        <thead>

                            <tr>
                                <th>Lot</th>
                                <th>Chamber</th>
                                <th>Customer</th>
                                <th>Bags</th>
                                <th>Weight</th>
                            </tr>

                        </thead>


                        <tbody>

                            {inventory.map(
                                item => (

                                    <tr key={item.id}>

                                        <td>
                                            {item.lotNo}
                                        </td>

                                        <td>
                                            {item.chamberNo}
                                        </td>

                                        <td>
                                            {item.customerName}
                                        </td>

                                        <td>
                                            {item.remainingBags}
                                        </td>

                                        <td>
                                            {item.remainingWeightTons}
                                            {" Tons"}
                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
};


export default Reports;